// extracted by mini-css-extract-plugin
export var chip = "_da-0";
export var filterDropdown = "_da-5";
export var filterItem = "_da-6";
export var icon = "_da-1";
export var removeButton = "_da-3";
export var removeIcon = "_da-4";
export var separator = "_da-2";